import { NetflixNewHotInfo } from "../WeddingInfo/WeddingInfo";

interface NetflixPreviewProps {
  newHot: NetflixNewHotInfo;
}

const NetflixPreview: React.FC<NetflixPreviewProps> = ({ newHot }) => {
  return (
    <div className="mx-4 mt-12">
      <div className="flex flex-col mt-4 text-left">
        <div className="text-white font-bold mb-4 text-xl">
          {newHot.title == "TAE HEE ❤️ HA YONG" ? "오늘의 주연" : "NEW & HOT"}
        </div>
        {newHot.title == "TAE HEE ❤️ HA YONG" ? (
          <div className="text-white font-bold mb-4 -mt-4 text-mb">
           단독 공개
          </div>
        ) : (
          <></>
        )}

        <div className="h-112 rounded-lg border-[0.5px] border-gray-500">
          {/* 동영상 영역 */}
          <div className="w-full h-56">
            <video
              src={newHot.videoURL}
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover rounded-lg"
            />
          </div>

          {/* 텍스트 & 버튼 그룹 */}
          <div className="flex flex-col justify-end pb-4 text-left mx-2 py-4">
            <div className="text-white font-medium text-xl">{newHot.title}</div>
            <div className="text-white text-md mt-2 whitespace-pre-line">
              {newHot.caption}
            </div>

            <div className="text-gray-300 text-md mt-2 whitespace-pre-line">
              {newHot.message}
            </div>

            {/* 버튼 그룹 */}
            <div
              className={`${
                newHot.title == "TAE HEE ❤️ HA YONG" ? "w-48" : "w-24"
              } flex space-x-4 mt-4`}
            >
              {/* 🔔 알림 받기 버튼 */}
              <button className="bg-white text-black font-medium px-2 py-2 rounded-sm text-sm">
                {newHot.title == "TAE HEE ❤️ HA YONG"
                  ? "💗 시리즈° 로맨스° 2026"
                  : "🔔 알림 받기"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NetflixPreview;
